/** Kort belletje bij een nieuwe controle-melding. Twee tonen via de WebAudio API,
 *  dus zonder extra geluidsbestand. Browsers laten dit toe zodra de gebruiker
 *  al eens geklikt heeft in de app. */
export function dingDong() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    [[988, 0], [784, 0.18]].forEach(([freq, at]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, ctx.currentTime + at);
      gain.gain.exponentialRampToValueAtTime(0.18, ctx.currentTime + at + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + at + 0.5);
      osc.connect(gain).connect(ctx.destination);
      osc.start(ctx.currentTime + at);
      osc.stop(ctx.currentTime + at + 0.55);
    });
    setTimeout(() => ctx.close(), 1500);
  } catch (e) { console.debug("Belletje kon niet spelen", e?.message); }
}
